import { NodesActions, NodesStore } from "stores/nodes/NodesStore";
const isLocalNode = async (nodeId) => {
  var _a, _b;
  const { nodes } = (_a = NodesStore.getInitialState()) != null ? _a : {};
  if (nodes) {
    return nodes[nodeId] !== void 0;
  }
  const response = await NodesActions.list();
  const requestedNode = ((_b = response == null ? void 0 : response.nodes) != null ? _b : []).filter((node) => (node == null ? void 0 : node.node_id) === nodeId);
  return requestedNode.length > 0;
};
export default isLocalNode;
